import { ArrowRight, ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { IMAGES, waLink, WA_MESSAGES } from "../../data";

const ChooseNeeds = () => (
  <section
    id="layanan"
    data-testid="choose-needs-section"
    className="border-b border-[#E5E2DA] bg-white py-20 lg:py-28"
  >
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal>
        <p className="font-tech mb-4 flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-[#525866]">
          <span className="inline-block h-[2px] w-10 bg-[#DF9F00]" />
          Rental &amp; Sales
          <span className="inline-block h-[2px] w-10 bg-[#DF9F00]" />
        </p>
        <div className="flex flex-wrap items-end justify-between gap-6">
          <h2 className="font-display text-3xl font-semibold uppercase tracking-wide text-[#141619] sm:text-4xl lg:text-5xl">
            APA YANG ANDA
            <br />
            BUTUHKAN<span className="text-[#DF9F00]">?</span>
          </h2>
          <p className="max-w-md text-base leading-relaxed text-[#525866]">
            Pilih kebutuhan steger Anda dan hubungi kami untuk mendapatkan
            penawaran.
          </p>
        </div>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <a
            href={waLink(WA_MESSAGES.rental)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="card-sewa-steger"
            className="group relative flex min-h-[440px] flex-col justify-end overflow-hidden rounded-2xl lg:min-h-[560px]"
          >
            <img
              src={IMAGES.crane}
              alt="Pekerja konstruksi menggunakan steger di lokasi proyek"
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
              loading="lazy"
              decoding="async"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/45 to-black/20 transition-opacity duration-500" />
            <span className="font-tech absolute left-6 top-6 flex items-center gap-2 rounded-full bg-[#DF9F00] px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#141619]">
              Layanan Utama
            </span>
            <div className="relative z-10 p-7 lg:p-10">
              <h3 className="font-display text-4xl font-semibold uppercase tracking-wide text-white lg:text-5xl">
                SEWA STEGER
              </h3>
              <p className="mt-4 max-w-md text-base leading-relaxed text-white/75">
                Solusi praktis untuk kebutuhan steger selama proyek berlangsung.
                Diantar langsung ke lokasi proyek Anda.
              </p>
              <span className="mt-8 inline-flex items-center gap-3 rounded-lg bg-[#DF9F00] px-6 py-3.5 text-sm font-bold uppercase tracking-[0.12em] text-[#141619] transition-colors duration-300 group-hover:bg-white">
                Sewa Sekarang
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </div>
          </a>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-5">
          <a
            href={waLink(WA_MESSAGES.buy)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="card-beli-steger"
            className="group relative flex min-h-[440px] flex-col justify-end overflow-hidden rounded-2xl lg:min-h-[560px]"
          >
            <img
              src={IMAGES.night}
              alt="Gedung bertingkat dengan steger pada malam hari"
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
              loading="lazy"
              decoding="async"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/55 to-black/30" />
            <span className="font-tech absolute left-6 top-6 flex items-center gap-2 rounded-full border border-white/30 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-white/80 backdrop-blur-sm">
              Kepemilikan Aset
            </span>
            <div className="relative z-10 p-7 lg:p-10">
              <h3 className="font-display text-3xl font-semibold uppercase tracking-wide text-white lg:text-4xl">
                BELI STEGER
              </h3>
              <p className="mt-4 max-w-sm text-base leading-relaxed text-white/75">
                Untuk kebutuhan penggunaan jangka panjang atau kepemilikan
                sendiri.
              </p>
              <span className="mt-8 inline-flex items-center gap-3 rounded-lg border border-white/50 px-6 py-3.5 text-sm font-bold uppercase tracking-[0.12em] text-white transition-colors duration-300 group-hover:border-[#DF9F00] group-hover:bg-[#DF9F00] group-hover:text-[#141619]">
                Tanya Harga
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </span>
            </div>
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);

export default ChooseNeeds;
